import { ApiErrorResponse } from '@/types/api'

export const getError = (
  data: { server_error?: string; error?: string },
  defaultMessage: string = 'Something went wrong'
): string => {
  if (!data) return defaultMessage

  return data.server_error || data.error || defaultMessage
}

export const humanizeErrors = (error: any) => {
  if (error?.errors && error?.errors.length > 0) {
    return error.errors.map((err: ApiErrorResponse) => err.message).join(', ')
  } else {
    return getError(error)
  }
}
